import React from 'react'
import { Form, Formik } from 'formik'
import { useHistory } from 'react-router-dom'
import Input from '../../components/common/Input'
import { required } from '../../utils/validators'
import Button from '../../components/common/Button'
import Select from '../../components/common/Select'
import { month } from '../../utils/types'

export default function UtilityBillsForm({ onSubmit, loading, initialValues, marketId }) {
    const handleSubmit = (vals, actions) => {
        const data = new FormData()
        data.append('electricity', vals.electricity || '')
        data.append('electricityIndex', vals.electricityIndex || '')
        data.append('water', vals.water || '')
        data.append('waterIndex', vals.waterIndex || '')
        data.append('gas', vals.gas || '')
        data.append('gasIndex', vals.gasIndex || '')
        data.append('garbage', vals.garbage || '')
        data.append('month', vals.month || '')
        data.append('market', marketId)
        onSubmit(data, actions)
    }
    const history = useHistory()

    return (
        <div className="box p-5">
            <h2 className="title is-4 has-text-centered">Коммунал тўловлар</h2>
            <Formik
                onSubmit={handleSubmit}
                initialValues={{
                    electricity: '',
                    electricityIndex: '',
                    water: '',
                    waterIndex: '',
                    gas: '',
                    gasIndex: '',
                    garbage: '',
                    month: '',
                    ...initialValues,
                }}
            >
                <Form>
                    <div className="columns is-multiline">
                        {/* Elektr tarmog'i */}
                        <div className="column is-half">
                            <Input name="electricity" placeholder="Электр сарфи (кВт)" label="Электр" validate={required} disabled={loading} />
                            <Input name="electricityIndex" label="Электр Ҳисоблагич Кўрсатгичи" validate={required} disabled={loading} />
                        </div>

                        {/* Suv tarmog'i */}
                        <div className="column is-half">
                            <Input name="water" placeholder="Сув сарфи (м³)" label="Сув" validate={required} disabled={loading} />
                            <Input name="waterIndex" label="Сув Ҳисоблагич Кўрсатгичи" validate={required} disabled={loading} />
                        </div>

                        {/* Gaz tarmog'i */}
                        <div className="column is-half">
                            <Input name="gas" placeholder="Газ сарфи (м³)" label="Газ" validate={required} disabled={loading} />
                            <Input name="gasIndex" label="Газ Ҳисоблагич Кўрсатгичи" validate={required} disabled={loading} />
                        </div>
                        <div className="column is-half">
                            <Select optionValue="value" optionLabel="name" name="month" label="Ойни танланг" options={month} validate={required} />
                        </div>

                        {/* Chiqindi */}
                        <div className="column is-half">
                            <Input name="garbage" label="Чиқинди" placeholder="Чиқинди тўлови" validate={required} disabled={loading} />
                        </div>
                    </div>

                    {/* Tugmalar */}
                    <div className="buttons is-justify-content-end">
                        <Button
                            onClick={() => {
                                history.push(`/rent/${marketId}/utility-bills`)
                            }}
                            icon="close-outline"
                            text="Бекор қилиш"
                            className="is-danger"
                        />
                        <Button loading={loading} text="Сақлаш" icon="add-outline" type="submit" className="is-success" />
                    </div>
                </Form>
            </Formik>
        </div>
    )
}
